import ServerSettings, {ServerSettingsFieldType} from "../../../gd/settings/server-settings/server-settings";

const fieldsConfig = {
    'files': {
        type            : ServerSettingsFieldType.VALUE,
        defaultValue    : {},
    },
}

// The CRM contact item view's settings for one company.
export default class UserSettings_CrmContact extends ServerSettings {

    // what CrmContact_FilesSettings keeps - the json FilesSettings.toJson() answers
    public files : JSONObject

    constructor(config: JSONObject) {
        super(config, fieldsConfig)

        this.files = this.initValue('files')
    }

    toJson() {
        const result = {}
        this.valueToJson(result, 'files')

        return result
    }
}
